// extracted by mini-css-extract-plugin
export default {"panel":"AccordionPanel_panel__BI4p0"};